module.exports = __webpack_public_path__ + "img/C87157_F8CBAE_E9A582_F2B394-256px.ba14d101.png";